export const formatInternationalPhoneNumber = (value: string): string => {
  // First, strip all non-digits and plus signs
  const cleaned = value.replace(/[^\d+]/g, '')

  // Handle different input formats
  let numbers = cleaned

  // If it starts with +1, remove the +1 and keep the rest
  if (numbers.startsWith('+1')) {
    numbers = numbers.slice(2)
  }
  // If it starts with 1 and has 11 digits total, remove the leading 1
  else if (numbers.startsWith('1') && numbers.length === 11) {
    numbers = numbers.slice(1)
  }
  // // If it starts with + but not +1, keep as is for other countries
  else if (numbers.startsWith('+') && !numbers.startsWith('+1')) {
    return numbers // Return as-is for non-US numbers
  }

  // Limit to 10 digits for US numbers
  const trimmed = numbers.slice(0, 10)

  // Format as +1 (XXX) XXX-XXXX
  const match = trimmed.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/)
  if (!match) return ''

  const [, first, second, third] = match

  if (!first) return '+1'
  if (!second) return `+1 (${first}`
  if (!third) return `+1 (${first}) ${second}`
  return `+1 (${first}) ${second}-${third}`
}
